import { render, staticRenderFns } from "./InstagramLoginForm.vue?vue&type=template&id=19ab69d4&"
import script from "./InstagramLoginForm.vue?vue&type=script&lang=js&"
export * from "./InstagramLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports